const desc = document.getElementsByClassName('description')[0];
const wrapper = document.getElementById('tabs-wrapper');
const tabs = [];
const panels = [];

if (desc) {
  desc.style.display = 'none';

  let tab = {
    heading: "",
    content: []
  };

  //   CREATE TAB OBJECTS FROM COLLECTION DESCRIPTION
  desc.childNodes.forEach((child, i) => {
    if (child.tagName == "H4") {
      if (tab.heading) tabs.push(tab);
      tab = {
        heading: "",
        content: []
      };
      tab.heading = child.innerHTML;
    } else {
      if (child.nodeName != "#text") tab.content.push("<p>" + child.innerHTML + "</p>")
    } 
  });

  tabs.push(tab)

  const list = document.createElement('UL');
  wrapper.append(list); 

  tabs.forEach((tab,i) => {
  //     CREATE PANEL OF CONTENT FOR EACH TAB
    const panel = document.createElement('DIV');
    panel.innerHTML = tab.content.join('');
    panel.id = "tab-" + i;
    panel.classList.add('tab-panel');
    panels.push(panel);
    if (i != 0) panel.style.display = "none";
    wrapper.append(panel)

  //     	CREATE HEADING FOR EACH TAB INCLUDING CLICK EVENT BEHAVIOR
    const item = document.createElement('LI');
    if (i == 0) {
      item.innerHTML = "<a class=\"active\" href=\"#tab-" + i + "\">" + tab.heading + "</a>";
    } else {
      item.innerHTML = "<a href=\"#tab-" + i + "\">" + tab.heading + "</a>";
    } 

    item.addEventListener('click', (e) => {
      e.preventDefault();
      [...list.getElementsByTagName('A')].forEach(a => a.classList.remove('active'));
      e.target.classList.add('active');
      panels.forEach(panel => panel.style.display = "none");
      document.getElementById(e.target.getAttribute("href").replace('#','')).style.display = 'block';
    });

    list.append(item)
  });
}
